import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';

export default function ClubMembershipSwitcher({ onClubSwitch }) {
  const { user, switchActiveClub, isSuperAdmin, impersonatedClubCode } = useAuth();
  const [switching, setSwitching] = useState(false);

  // Membership switcher is scoped to clubs this login belongs to.
  // The all-clubs list lives only in ClubSwitcher (superadmin).
  const memberships = user?.clubMemberships?.length
    ? user.clubMemberships
    : (user?.clubs || []).map((clubCode) => ({
        clubCode,
        displayName: clubCode
      }));

  if (!user || memberships.length <= 1) {
    return null;
  }

  // Superadmin impersonation uses ClubSwitcher + X-Club-Code, not membership switching
  if (isSuperAdmin() && impersonatedClubCode) {
    return null;
  }

  const handleChange = async (event) => {
    const nextClub = event.target.value;
    if (!nextClub || nextClub === user.clubCode || switching) return;

    setSwitching(true);
    const result = await switchActiveClub(nextClub);
    setSwitching(false);

    if (result.success) {
      onClubSwitch?.(nextClub);
    } else {
      alert(result.error || 'Failed to switch club');
    }
  };

  return (
    <div className="flex items-center gap-2">
      <label htmlFor="club-membership-switcher" className="text-xs text-white/80 hidden sm:inline">
        Club
      </label>
      <select
        id="club-membership-switcher"
        value={user.clubCode || memberships[0].clubCode}
        onChange={handleChange}
        disabled={switching}
        className="text-sm rounded-lg px-2 py-1.5 bg-white/95 text-theme-primary border border-white/30 max-w-[140px] sm:max-w-[200px] truncate disabled:opacity-60"
        aria-label="Switch active club"
      >
        {memberships.map((membership) => (
          <option key={membership.clubCode} value={membership.clubCode}>
            {membership.displayName || membership.clubCode}
          </option>
        ))}
      </select>
    </div>
  );
}
